'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Indicator = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 4px;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 4px;\n"])));
var GreyIndicator = styled__default(Indicator)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
});
var PrimaryIndicator = styled__default(Indicator)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var ExpandIndicator = function (_a) {
    var nestingLevel = _a.nestingLevel, expanded = _a.expanded;
    if (expanded && nestingLevel === 0) {
        return (React__default.createElement(PrimaryIndicator, null));
    }
    if (nestingLevel > 0) {
        return (React__default.createElement(GreyIndicator, null));
    }
    return null;
};
var templateObject_1, templateObject_2, templateObject_3;

exports.ExpandIndicator = ExpandIndicator;
exports.GreyIndicator = GreyIndicator;
exports.PrimaryIndicator = PrimaryIndicator;
